import { useContent } from "../lib/content";
import WhatsAppIcon from "./WhatsAppIcon";

export default function WhatsAppFloat() {
  const { socials } = useContent();
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={`https://wa.me/${(socials.whatsapp || "").replace(/\D/g, "")}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_16px_40px_-10px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform duration-300"
    >
      <WhatsAppIcon className="w-7 h-7" />
    </a>
  );
}
